import { Box, Center, Spinner } from "@chakra-ui/react";
import { GetLayout } from "components/get-layout";
import { useVendeAi } from "utils/active-vende-ai";

export function VendeAIPage() {
  const vendeAiData = useVendeAi();
  const url = vendeAiData.detailsDashboardLink;

  return (
    <GetLayout pageContentProps={{ p: 0 }}>
      {url ? (
        <Box
          as="iframe"
          src={url}
          title="Painel de Relatórios do Looker Studio"
          width="100%"
          height="calc(100vh - 80px)"
          border="0"
          allowFullScreen
        />
      ) : (
        <Center w="100%" h="100%">
          <Spinner />
        </Center>
      )}
    </GetLayout>
  );
}
